export default {
    ENV: 'rc',
    authApiUrl: 'https://rcapi.imaginelearning.com',
    redirectUri: 'https://rc.my.imaginelearning.com/login/signin',
    auth0RedirectUri: 'https://rc.my.imaginelearning.com/login/sso',
    auth0Audience: 'https://api.my.imaginelearning.com',
    auth0AuthorizeUrl: 'https://imaginelearning-rc.auth0.com/authorize',
    auth0ClientId: 'z9KtV7-ou_Rvcy8EZ_Ig0zhY_Dzf7XA0',
    unityLaunchUrl: 'https://rc.my.imaginelearning.com/player',
    pssUrl: 'https://rcapi.imaginelearning.com/productSelection',
    imlpApiUrl: 'https://identity.staging.edgenuityapp.com/api',
    oauthSsoUrl: 'https://identity.staging.edgenuityapp.com/api/auth/sso/oauth',
    cleverSsoUrl: 'https://identity.staging.edgenuityapp.com/api/auth/sso/clever',
    imlpIlApiUrl: 'https://identity-staging.imaginelearning.com/api',
    oauthSsoIlUrl: 'https://identity-staging.imaginelearning.com/api/auth/sso/oauth',
    cleverSsoIlUrl: 'https://identity-staging.imaginelearning.com/api/auth/sso/clever',
    permissionsApiUrl: 'https://rcapi.imaginelearning.com/v1.0/permissions',
    configCatApiUrl: 'https://flag-proxy.platform-nonprod.imaginelearning.com',
    configCatSdkKey: 'configcat-proxy/axs-sso-imlp-staging',
    configCatPollIntervalSeconds: 60,
    configCatRequestTimeoutMs: 30000,
    configCatMaxRetries: 3
};
